interface DistrictIdentity {
  name: string
  city: string
}

export const districtDetailUrl = ({ name, city }: DistrictIdentity) =>
  `/admin/schools/district?${new URLSearchParams({ name, city })}`

export const adminDistrictUrl = ({ name, city }: DistrictIdentity) =>
  `/admin/districts/lookup/by-name?${new URLSearchParams({
    district_name: name,
    city,
  })}`
